import { curryN, gte, length, pipe } from 'ramda';

import { fetchValue } from './util';

export default curryN(2, (len, value) =>
  pipe(fetchValue, length, gte(len))(value)
);
